import axios from "axios";
import Cookies from "js-cookie";
import { getUTMParametersForSubmission } from "./utm";

export const HUBSPOT_PORTAL_ID = "23610499";
export const HUBSPOT_CONTACT_US_FORM_GUID = "4e500305-2e6b-4bed-b258-99fddd24154b";
export const HUBSPOT_WATCH_DEMO_FORM_GUID = "01a82170-ba1f-4a66-b9e3-6763cd5a71e9";
export const HUBSPOT_START_NOW_FORM_GUID = "8c0b407e-db8f-4851-8c12-e6bec57f4bfb";
export const HUBSPOT_GET_STARTED_FORM_ID = "f29d2be7-1980-419e-8507-8c5516cb6983";
export const GET_STARTED_FORM_EVENT_TRIGGER = "submit_getstarted_form";

export interface HubspotFormField {
  name: string;
  value: string | undefined;
}

export const HUBSPOT_EMBED_CODE = `https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
export const HUBSPOT_EMBED_ID = "hs-script-loader";

export interface SubmitHubspotFormOptions {
  /**
   * Additional fields to include in the submission
   */
  additionalFields?: Record<string, string>;
  /**
   * Whether to include UTM parameters automatically (default: true)
   */
  excludeUTMParameters?: boolean;
}

export const submitHubspotForm = async (
  guid: string,
  fields: HubspotFormField[],
  options?: SubmitHubspotFormOptions,
) => {
  const { additionalFields = {}, excludeUTMParameters = false } = options ?? {};

  // Collect UTM parameters if enabled
  const utmParams = excludeUTMParameters ? {} : getUTMParametersForSubmission();

  // Combine all additional fields
  const allAdditionalFields = { ...utmParams, ...additionalFields };

  // Convert additional fields to HubspotFormField format
  const additionalFieldsArray: HubspotFormField[] = Object.entries(allAdditionalFields).map(
    ([name, value]) => ({
      name,
      value,
    }),
  );

  // Combine user-provided fields with additional fields
  const allFields = [...fields, ...additionalFieldsArray].filter((field) => field.value != null);

  // this is the hubspot analytics tracking cookie
  const hubspotutk = Cookies.get("hubspotutk");
  return await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${guid}`,
    {
      fields: allFields,
      context: {
        hutk: hubspotutk,
        pageUri: window.location.href,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const PERSONAL_EMAIL_REGEX = new RegExp(
  /(@gmail\.com|@hotmail\.com|@msn\.com|@yahoo\.com|@outlook\.com)$/i,
);

export const emailIsPersonalEmail = (email: string) => PERSONAL_EMAIL_REGEX.test(email);
